<template>
  <div class="about">
		<div class="action_bar"></div>
		<main>
			<h1>Records</h1>

			<div class="records--primary">
				<ul>
					<li><button class="list_item" @click="viewClaims = true">Claims</button></li>
					<li><button class="list_item" @click="viewPatients = true">Patients</button></li>
					<li>
						<button class="list_item" @click="viewPatients = true">
							<div>Unprocessed LabelSnaps</div>
							<div class="indicator">12</div>
						</button>
					</li>
					<li><button class="list_item" @click="viewGroups = true">Groups</button></li>
				</ul>
			</div>

			<div class="records--secondary">
				<h5>Financial</h5>
				<ul>
					<li>
						<button class="list_item">
							<div>MSP payments</div>
							<div class="indicator"></div>
						</button>
					</li>
					<li>
						<button class="list_item">
							<div>Claims in recovery</div>
							<div class="indicator">$3,588</div>
						</button>
					</li>
					<li>
						<button class="list_item">
							<div>Income statement</div>
							<div class="indicator">$184,553</div>
						</button>
					</li>
					<!-- <li>
						<button class="list_item">
							<div>Recover claims</div>
							<div class="indicator">$8,254</div>
						</button>
					</li> -->
				</ul>
			</div>

    </main>


    <transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="viewClaims">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewClaims = false"></button>
				</div>
				<div class="modalView--container">
					<h1>Claims</h1>

					<div class="sort--container">
						<div class="sort--item"><span>Sort by:</span> Newest to oldest</div>
						<!-- <div class="sort--item">Status</div>
						<div class="sort--item">Unpaid</div> -->
					</div>
				</div>
			</ModalView>
		</transition>

		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="viewPatients">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewPatients = false"></button>
					<button class="action_bar--text_action">Edit</button>
				</div>
				<div class="modalView--container">
					<h1>Patients</h1>
				</div>
			</ModalView>
		</transition>

		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="viewGroups">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewGroups = false"></button>
					<button class="action_bar--text_action">Edit</button>
				</div>
				<div class="modalView--container">
					<h1>Groups</h1>
				</div>
			</ModalView>
		</transition>
  </div>
</template>


<script>
import ModalView from '@/components/ModalView.vue'

export default {
	components: {
    ModalView,
  },
	data: function () {
    return {
			viewClaims: false,
			viewPatients: false,
			viewGroups: false,
    }
  }
}
</script>


<style scoped>
.about {
	bottom: env(safe-area-inset-bottom);
	left: 0;
	position: fixed;
	right: 0;
	top: env(safe-area-inset-top);
}
main {
	padding: 0 1rem 1rem;
}

.title--wrapper {
	display: flex;
	justify-content: space-between;
}
h1 {
	font-weight: 700;
	margin-bottom: 1.5rem;
}
ul,
li {
	border: none;
}


.button--search {
	background: pink url('/img/icon--search.svg') no-repeat center center;
}


.records--primary {
	/*bottom: calc(48px + env(safe-area-inset-bottom) );
	left: 0;
	padding-left: 1rem;
	padding-right: 1rem;
	position: absolute;
	right: 0;*/
	margin-bottom: 2rem;
}
.records--secondary {

}
.list_item {
	align-items: center;
	background: url('/img/icon--chevron--right.svg') no-repeat right center;
	display: flex;
	font-family: system-ui;
	font-size: 19px;
	font-weight: 500;
	justify-content: space-between;
	height: 48px;
	padding-left: 0;
	padding-right: 2rem;
	width: 100%;
}


.indicator {
	color: #999;
	font-weight: 400;
}


.modalView--container h1 {
	margin-bottom: 0.5rem;
}
.sort--container {
	align-items: center;
	/*background-color: #f7f7f7;*/
	/*border-bottom: 1px solid #eee;
	border-top: 1px solid #eee;*/
	display: flex;
	height: 48px;
	margin-left: -1rem;
	padding-left: 1rem;
	padding-right: 1rem;
	width: calc(100% + 2rem);
}
.sort--item {
	/*background: url('/img/icon--sort_direction.svg') no-repeat left center;*/
	/*align-items: center;*/
	border: 1px solid #ddd;
	border-radius: 8px;
	color: #555;
	display: flex;
	font-style: 17px;
	font-weight: 500;
	height: 36px;
	line-height: 35px;
	padding-left: 0.75rem;
	padding-right: 0.75rem;	
}
.sort--item span {
	color: #999;
	font-size: 13px;
	line-height: 35px;
	margin-right: 0.5rem;
	text-transform: uppercase;
}
.sort--item.active {
	background-color: #f3f3f3;
	color: #444;
}
.sort--item + .sort--item {
	margin-left: 0.5rem;
}
</style>